import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";

let apiAbortController: AbortController | null = null;
const getFilesForLeadId = async (
  leadId: string,
  limit: number = 10,
  skip: number = 0,
  filterCat: string = "all"
) => {
  // Cancel previous request if it exists
  if (apiAbortController) {
    apiAbortController.abort();
  }

  // Create a new AbortController for the current request
  apiAbortController = new AbortController();
  try {
    const url = new URL(
      `${config.baseURL}/api/files?limit=${limit}&skip=${skip}&relatedLead=${leadId}`
    );
    if (filterCat !== "all") url.searchParams.set("category", filterCat);
    const response = await AUTH_GET(url.toString(), {
      revalidate: 60,
      tags: ["lead", leadId, `${leadId}-files`],
      signal: apiAbortController?.signal,
    });

    apiAbortController = null; // Clear the controller after successful request
    return response;
  } catch (error: any) {
    console.log({ error });
    if (error.name === "AbortError") {
      // Handle fetch cancellation
      console.log("Fetch request canceled");
    } else {
      // Handle other errors
      throw error;
    }
  }
};

export default getFilesForLeadId;
